import React, { useState, useEffect } from 'react';
import { IoMdEye } from 'react-icons/io';
import { CiEdit } from 'react-icons/ci';
import { MdDelete } from "react-icons/md";
import { FaUserLock } from "react-icons/fa";
import { Button, Pagination } from '@mui/material';
import { json, useNavigate } from 'react-router-dom';
import ViewAllEmployees from '../../../component/b2c/models/ViewAllEmployee';
import { useMyContext } from '../../../context/MyContext';
import Sidebar from '../../../component/b2c/sidebar/sidebar';
import NavBar from '../../../component/b2c/navBar/navBar';
import PaginationItem from '@mui/material/PaginationItem';
import '../../../css/custom-scrollbar.css';
import { HiUsers } from "react-icons/hi";
import { toast } from 'react-toastify';
import { Base_Url, AllEmployeeList, deleteEpmloyee } from '../../../config/config';
import SetPermission from '../../../component/b2c/models/setPermissionModel';

const AllEmployee = () => {
  const [totalOrders, setTotalOrders] = useState(0);
  const { isDarkMode } = useMyContext();
  const [isPopupOpenPermission, setIsPopupOpenPermission] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const { isToggleSidebar,setIsToggleSidebar } = useMyContext();
  const [employee, setEmployee] = useState([]);
  const [empLoyeePermission, setEmployeePermission] = useState(null);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const itemsPerPage = 8;

  const navigate = useNavigate();

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  useEffect(() => {
    fetchWarehouses();
  }, [page, limit, setEmployee]);


  const fetchWarehouses = async () => {
    const token = localStorage.getItem('token');
    const cusid = localStorage.getItem('cus_id');
    try {
      const pageNumber = Number(page) || 1;
      const limitNumber = Number(limit) || 10;
      const url_for_allEmployee = `${Base_Url}${AllEmployeeList}?page=${pageNumber}&limit=${limitNumber}`
      const response = await fetch(url_for_allEmployee, {
        method: 'GET',
        headers: {
          'token': token,
          'cus_id': cusid,
          'Content-Type': 'application/json'
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      if (result.status === "SUCCESS") {
        setEmployee(result.data);
        setTotalOrders(result.pagination.totalItems || 0);
      } else {
      }
    } catch (error) {
    }
  };


  const handlePaginationChange = (event, value) => {
    setPage(value);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
    setPage(1);
  };


  const handleViewClick = (employee) => {
    setSelectedEmployee(employee);
    setIsPopupOpen(true);
  };


  const handleClose = () => {
    setIsPopupOpen(false);
  };


  const handleViewPermissionPopup = (employee) => {
    setIsPopupOpenPermission(true);
    setEmployeePermission(employee);

  }

  const handleClosePermissionPopup = () => {
    setIsPopupOpenPermission(false);
  };


  const handleNavigation = () => {
    navigate('/dashboard');
  };

  const handleDelete = async (id) => {
    const urldelete = Base_Url + deleteEpmloyee;

    try {
      const token = localStorage.getItem('token');
      const cusid = localStorage.getItem('cus_id');

      const response = await fetch(`${urldelete}/${id}`, {
        method: 'GET',
        headers: {
          token,
          cus_id: cusid,
          'Content-Type': 'application/json',
        },
      });

      const data = await response.json();

      if (data.status === "success") {
        setEmployee((prevWarehouses) => prevWarehouses.filter(employee => employee.id !== id));
        toast.success(data.message);
        setTotalOrders((prev) => prev - 1);
        fetchWarehouses();

      } else {
        toast.error(data.message);
      }

    } catch (error) {
      toast.error(error.message);
    }
  };

  const glass =
    "backdrop-blur-2xl backdrop-saturate-150 bg-white/50 dark:bg-white/[0.06] " +
    "border border-white/60 dark:border-white/10 " +
    "shadow-[0_8px_32px_rgba(31,41,55,0.08)]";

  return (
    <>
      <div className={`h-screen flex flex-col overflow-hidden transition-colors duration-300 ${isDarkMode ? 'dark bg-[#0B1120]' : 'bg-gray-50'
        }`}>
        {/* Premium ambient glows */}
        {isDarkMode && (
          <>
            <div className="pointer-events-none absolute -top-40 -left-32 h-[500px] w-[500px] rounded-full bg-indigo-600/15 blur-[120px]" />
            <div className="pointer-events-none absolute bottom-0 -right-32 h-[400px] w-[400px] rounded-full bg-purple-600/10 blur-[100px]" />
          </>
        )}

        <div className="z-10 shrink-0">
          <NavBar />
        </div>

        <div className="flex flex-1 overflow-hidden relative z-10">
                   {isToggleSidebar && (
          <div
            className="fixed inset-0 z-40 bg-black/40 backdrop-blur-sm md:hidden"
            onClick={() => setIsToggleSidebar(false)}
          />
        )}

        <div
          className={`
                     fixed inset-y-0 left-0 z-50 w-64
                     ${isToggleSidebar ? "translate-x-0" : "-translate-x-full"}
                     md:static md:inset-auto md:z-auto md:translate-x-0
                     ${isToggleSidebar ? "md:w-64" : "md:w-[72px]"}
                     m-3
                     rounded-3xl
                 
                     overflow-hidden
                     transition-all
                     duration-300
                     ease-in-out
                   `}
        >
          <Sidebar />
        </div>

          <div className={`flex-1 p-4 md:p-5 w-full overflow-hidden flex flex-col transition-colors duration-300 ${isDarkMode ? 'bg-[#0B1120]' : 'bg-gray-200'
            }`}>

            {/* Premium Header */}
            <div className="flex-shrink-0 mb-4">
              <div className="flex items-center gap-3">
                <div className={`p-2.5 rounded-xl border transition-all duration-300 ${isDarkMode
                    ? 'bg-gradient-to-br from-indigo-500/20 to-purple-500/10 border-indigo-500/30 shadow-[0_0_20px_rgba(99,102,241,0.2)]'
                    : 'bg-gradient-to-br from-blue-600 to-indigo-600'
                  }`}>
                  <HiUsers size={16} className="text-white" />
                </div>
                <div>
                  <h1 className={`text-sm font-bold tracking-tight transition-colors duration-300 ${isDarkMode ? 'text-white' : 'text-gray-800'
                    }`}>All Employees</h1>
                  <p className={`text-[10px] transition-colors duration-300 ${isDarkMode ? 'text-gray-500' : 'text-gray-500'
                    }`}>Manage your team members and permissions</p>
                </div>
                <span className={`ml-auto text-[10px] font-bold px-3 py-1 rounded-full border transition-colors duration-300 ${isDarkMode
                    ? 'border-indigo-500/30 text-indigo-300 bg-indigo-500/10'
                    : 'border-gray-300 text-gray-500'
                  }`}>
                  {totalOrders} total
                </span>
              </div>
            </div>

            {/* Premium Table */}
            <div className={`flex-1 overflow-y-auto overflow-x-auto custom-scrollbar rounded-xl border transition-colors duration-300 ${isDarkMode
                ? 'border-gray-800 bg-[#111827] shadow-[0_0_30px_rgba(0,0,0,0.4)]'
                : 'border-gray-200'
              }`}>
              <table className="min-w-full w-full border-collapse table-auto">
                <thead className="sticky top-0 z-10">
                  <tr className={`text-[9px] uppercase tracking-wider transition-colors duration-300 ${isDarkMode
                      ? 'bg-gradient-to-r from-[#1F2937] via-[#1a2332] to-[#1F2937] text-gray-300 border-b border-gray-700'
                      : 'bg-blue-600 text-white'
                    }`}>
                    <th className="p-2.5 text-left w-12 font-semibold">ID</th>
                    <th className="p-2.5 text-left font-semibold">Name</th>
                    <th className="p-2.5 text-left font-semibold hidden sm:table-cell">Email</th>
                    <th className="p-2.5 text-left w-24 font-semibold">Phone</th>
                    <th className="p-2.5 text-center w-36 font-semibold">Actions</th>
                  </tr>
                </thead>
                <tbody className={`divide-y transition-colors duration-300 ${isDarkMode ? 'divide-gray-800' : 'divide-gray-100'
                  }`}>
                  {employee.reverse().map((employee, index) => (
                    <tr
                      key={employee.id}
                      className={`transition-colors duration-150 ${isDarkMode
                          ? index % 2 === 0 ? 'bg-[#111827] hover:bg-[#1F2937]' : 'bg-[#0F172A] hover:bg-[#1F2937]'
                          : index % 2 === 0 ? 'bg-white hover:bg-gray-50' : 'bg-gray-50/50 hover:bg-gray-50'
                        }`}
                    >
                      <td className={`p-2.5 text-[10px] font-mono transition-colors duration-300 ${isDarkMode ? 'text-indigo-300' : 'text-gray-500'
                        }`}>{employee.id}</td>
                      <td className={`p-2.5 text-[10px] font-semibold transition-colors duration-300 ${isDarkMode ? 'text-gray-200' : 'text-gray-800'
                        }`}>{employee.name}</td>
                      <td className={`p-2.5 text-[10px] hidden sm:table-cell transition-colors duration-300 ${isDarkMode ? 'text-gray-400' : 'text-gray-600'
                        }`}>{employee.email}</td>
                      <td className={`p-2.5 text-[10px] font-mono transition-colors duration-300 ${isDarkMode ? 'text-gray-400' : 'text-gray-600'
                        }`}>{employee.phone}</td>
                      <td className="p-2.5">
                        <div className="flex items-center justify-center gap-1.5">
                          <button
                            onClick={() => handleViewClick(employee)}
                            title="View"
                            className={`w-7 h-7 flex items-center justify-center rounded-lg border transition-all duration-300 ${isDarkMode
                                ? 'border-indigo-500/40 text-indigo-300 hover:bg-indigo-500/10 hover:shadow-[0_0_10px_rgba(99,102,241,0.4)]'
                                : 'border-gray-300 text-gray-600 hover:bg-black hover:text-white hover:border-black'
                              }`}
                          >
                            <IoMdEye size={13} />
                          </button>
                          <button
                            title="Edit"
                            className={`w-7 h-7 flex items-center justify-center rounded-lg border transition-all duration-300 ${isDarkMode
                                ? 'border-amber-500/40 text-amber-300 hover:bg-amber-500/10 hover:shadow-[0_0_10px_rgba(245,158,11,0.4)]'
                                : 'border-gray-300 text-gray-600 hover:bg-black hover:text-white hover:border-black'
                              }`}
                          >
                            <CiEdit size={13} />
                          </button>
                          <button
                            onClick={() => handleDelete(employee.employee_id)}
                            title="Delete"
                            className={`w-7 h-7 flex items-center justify-center rounded-lg border transition-all duration-300 ${isDarkMode
                                ? 'border-rose-500/40 text-rose-400 hover:bg-rose-500/10 hover:shadow-[0_0_10px_rgba(244,63,94,0.4)]'
                                : 'border-gray-300 text-gray-600 hover:bg-black hover:text-white hover:border-black'
                              }`}
                          >
                            <MdDelete size={13} />
                          </button>
                          <button
                            onClick={() => handleViewPermissionPopup(employee)}
                            title="Permissions"
                            className={`w-7 h-7 flex items-center justify-center rounded-lg border transition-all duration-300 ${isDarkMode
                                ? 'border-emerald-500/40 text-emerald-300 hover:bg-emerald-500/10 hover:shadow-[0_0_10px_rgba(16,185,129,0.4)]'
                                : 'border-gray-300 text-gray-600 hover:bg-black hover:text-white hover:border-black'
                              }`}
                          >
                            <FaUserLock size={12} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                  {employee.length === 0 && (
                    <tr>
                      <td colSpan="5" className={`p-6 text-center text-[11px] transition-colors duration-300 ${isDarkMode ? 'text-gray-500' : 'text-gray-400'
                        }`}>
                        No employees found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Premium Pagination Footer */}
            <div className={`flex-shrink-0 mt-3 pt-3 border-t flex flex-col sm:flex-row justify-between items-center gap-2 transition-colors duration-300 ${isDarkMode ? 'border-gray-800' : 'border-gray-200'
              }`}>
              <span className={`text-[9px] font-medium transition-colors duration-300 ${isDarkMode ? 'text-gray-400' : 'text-gray-500'
                }`}>
                Total: <span className={`font-bold ${isDarkMode ? 'text-indigo-300' : 'text-gray-800'}`}>{totalOrders}</span> employees
              </span>

              <div className="flex items-center gap-2">
                <select
                  id="limit"
                  value={limit}
                  onChange={handleLimitChange}
                  className={`rounded-lg px-2.5 py-1 text-[9px] border focus:outline-none focus:ring-1 transition-colors duration-300 ${isDarkMode
                      ? 'bg-[#1F2937] border-gray-700 text-white focus:ring-indigo-500'
                      : 'bg-white border-gray-300 text-gray-700 focus:ring-gray-400'
                    }`}
                >
                  <option value={10}>10</option>
                  <option value={15}>15</option>
                  <option value={totalOrders}>All</option>
                </select>

                <Pagination
                  count={Math.ceil(totalOrders / limit)}
                  page={page}
                  onChange={handlePaginationChange}
                  variant="outlined"
                  shape="rounded"
                  size="small"
                  sx={{
                    '& .MuiPaginationItem-root': {
                      fontSize: '10px',
                      borderColor: isDarkMode ? '#374151' : '#d1d5db',
                      color: isDarkMode ? '#E5E7EB' : '#000',
                      '&.Mui-selected': {
                        backgroundColor: isDarkMode ? 'rgba(99,102,241,0.2)' : '#000',
                        color: isDarkMode ? '#a5b4fc' : '#fff',
                        borderColor: isDarkMode ? '#6366f1' : '#000',
                        boxShadow: isDarkMode ? '0 0 10px rgba(99,102,241,0.4)' : 'none',
                      },
                      '&:hover': {
                        backgroundColor: isDarkMode ? 'rgba(99,102,241,0.1)' : '#F3F4F6',
                      },
                    },
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <ViewAllEmployees isopen={isPopupOpen} onClose={handleClose} employee={selectedEmployee} />
        <SetPermission isopen={isPopupOpenPermission} onClose={handleClosePermissionPopup} selectedEmpForSetPermission={empLoyeePermission} />
      </div>
    </>
  );
};

export default AllEmployee;